export default "__VITE_ASSET__sFjendxs__"